import { FillingMethod } from 'entities/FormField';
import { FieldType } from 'entities/common';

import { IFormFieldModel } from './interface';

export const FORM_FIELD_DEFAULT_VALUES = {
  SUPERVISOR_VISIBILITY: true,
  PIVOT_SCREEN_VISIBILITY: false,
  DEFAULT_VISIBILITY: true,
  IMPORT_EDITABLE: false,
  FILLING_METHOD: FillingMethod.import,
  DEFAULT_VALUE: null,
  DATA_TYPE: FieldType.str,
  NAME: '',
};

export const PIVOT_SCREEN_TOGGLE_AVAILABLE_DATA_TYPES: FieldType[] = [
  FieldType.int,
  FieldType.percent,
  FieldType.enum,
  FieldType.formula,
];

export const DATA_TYPES_WITHOUT_FILLING_METHOD = [FieldType.formula];

/* Некоторые типы данных идут без методов заполнения ( заполняются через форму автоматически )*/
export const isDataTypeWithoutFillingMethod = (
  record: IFormFieldModel
): boolean => {
  if (record.custom && record.selectModel.value) {
    return DATA_TYPES_WITHOUT_FILLING_METHOD.includes(record.selectModel.value);
  }

  return DATA_TYPES_WITHOUT_FILLING_METHOD.includes(record.fieldData.dataType);
};
